// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__38oN6","newExpiryDate":"styles_newExpiryDate__7YIfK","footer":"styles_footer__2WNJo"};